module.exports = __webpack_public_path__ + "img/alert-white.ba260d70.svg";